import {updateCustomShapeTemplate, uploadDesignLibraryTemplate} from '../../../services/ArtworkTemplateServices'

/**
 * @param {{ getPreviewImage?: () => string | null | Promise<string | null> }} [options]
 *   getPreviewImage: async function that captures overlay, uploads to S3, returns S3 link for preview_image.
 */
export function RemotePersistentService(options = {}) {
    const {getPreviewImage} = options

    const DEFAULT_METADATA = {name: 'Custom Shape', description: 'Custom Shape'}

    return {
        /**
         * Save document to the remote server.
         * If metadata.id is provided, updates the existing template; otherwise creates a new one.
         * @param {string} raw - Serialized editor document JSON string
         * @param {{ id?: string, name?: string, description?: string }} [metadata] - Optional metadata overrides
         */
        save: async (raw, metadata) => {
            const {id, name, description} = {...DEFAULT_METADATA, ...metadata}
            const parsedData = JSON.parse(raw)
            const preview_image = getPreviewImage
                ? await Promise.resolve(getPreviewImage())
                : (parsedData.preview_image ?? null)

            const payload = {
                name,
                description,
                preview_image,
                width: 0,
                height: 0,
                layers: [],
                data: parsedData,
                type: 'custom_shape',
            }

            const {success, data} = id
                ? await updateCustomShapeTemplate({...payload, id})
                : await uploadDesignLibraryTemplate(payload)

            if (!success) {
                throw new Error(id ? 'Failed to update template' : 'Failed to save template')
            }
            return data
        },

        load: async (doc) => {
            return doc ? JSON.parse(doc) : null
        },
    }
}
